// extracted by mini-css-extract-plugin
module.exports = {"bottomFixedWrapper":"bottomFixedWrapper--31LHu","btn":"btn--kCVuA","wbtn":"wbtn--v1ppH"};